import React, { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import LenderGrid from "./LenderGrid";
import "./eligibility.css";
import "./eligibilitymobile.css";

export default function EligibilityResults() {
  const location = useLocation();

  const localResult = (() => {
    try {
      return JSON.parse(localStorage.getItem("eligibilityResult"));
    } catch {
      return null;
    }
  })();

  const rawResult = location.state?.result || localResult;

  const result = useMemo(() => {
    if (!rawResult?.eligible || !rawResult.banks) return rawResult;
    return {
      ...rawResult,
      banks: rawResult.banks.map((bank) => ({
        ...bank,
        tenure: bank.tenure || 60,
      })),
    };
  }, [rawResult]);

  const [loanAmount, setLoanAmount] = useState("");
  const [loanTenure, setLoanTenure] = useState("");
  const [sortField, setSortField] = useState("rate");
  const [sortOrder, setSortOrder] = useState("asc");

  if (!result || !result.eligible) {
    return (
      <div className="results-empty">
        <h2>Not eligible based on current estimates</h2>
        <p className="results-note">
          These reasons are indicative. A lender may still review your full profile differently.
        </p>
        <ul>{result?.reasons?.map((r, i) => <li key={i}>{r}</li>)}</ul>
      </div>
    );
  }

  const sortBy =
    sortField === "amount"
      ? sortOrder === "asc"
        ? "amount-asc"
        : "amount"
      : sortOrder === "asc"
        ? "rate-asc"
        : "rate";

  return (
    <div className="eligibility-results-container">
      <aside className="filters-sidebar">
        <h3>Refine estimates</h3>

        <div>
          <label htmlFor="loanAmount">Loan amount (₹)</label>
          <input
            id="loanAmount"
            type="number"
            value={loanAmount}
            onChange={(e) => setLoanAmount(e.target.value)}
            placeholder="e.g. 500000"
          />

          <label htmlFor="loanTenure">Tenure (months)</label>
          <input
            id="loanTenure"
            type="number"
            value={loanTenure}
            onChange={(e) => setLoanTenure(e.target.value)}
            placeholder="e.g. 48"
          />
        </div>

        <label>Sort by eligible amount</label>
        <div className="radio-group">
          <label className="radio-option">
            <input
              type="radio"
              name="amountSort"
              checked={sortField === "amount" && sortOrder === "asc"}
              onChange={() => {
                setSortField("amount");
                setSortOrder("asc");
              }}
            />
            <span>Low to high</span>
          </label>
          <label className="radio-option">
            <input
              type="radio"
              name="amountSort"
              checked={sortField === "amount" && sortOrder === "desc"}
              onChange={() => {
                setSortField("amount");
                setSortOrder("desc");
              }}
            />
            <span>High to low</span>
          </label>
        </div>

        <label>Sort by interest rate</label>
        <div className="radio-group">
          <label className="radio-option">
            <input
              type="radio"
              name="rateSort"
              checked={sortField === "rate" && sortOrder === "asc"}
              onChange={() => {
                setSortField("rate");
                setSortOrder("asc");
              }}
            />
            <span>Low to high</span>
          </label>
          <label className="radio-option">
            <input
              type="radio"
              name="rateSort"
              checked={sortField === "rate" && sortOrder === "desc"}
              onChange={() => {
                setSortField("rate");
                setSortOrder("desc");
              }}
            />
            <span>High to low</span>
          </label>
        </div>
      </aside>

      <div className="results-main">
        <h2>Estimated eligibility</h2>
        <p className="results-note">
          These figures are estimates only. Final approval, rate, and amount depend on credit score and lender policy.
        </p>

        <LenderGrid
          banks={result.banks}
          mode="dynamic"
          sortBy={sortBy}
          loanTenure={loanTenure || 60}
        />
      </div>
    </div>
  );
}
